import { useEffect, useState } from "react";
import { Alert, Button, Checkbox, FormControlLabel, Grid, Paper, TextField, Typography } from "@mui/material";
import api from "lib/api/api";

const AusbildungInterestForm = ({ categoryId, categoryName, profile, isArabic, language }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "", notifyWhenAvailable: true });
  const [status, setStatus] = useState({ sending: false, success: "", error: "" });

  useEffect(() => {
    setForm((current) => ({
      ...current,
      name: current.name || [profile?.firstName, profile?.lastName].filter(Boolean).join(" "),
      email: current.email || profile?.email || "",
      phone: current.phone || profile?.phoneNumber || profile?.phone || "",
    }));
  }, [profile]);

  const text = language === "de" ? {
    title: "Interesse an einer Ausbildung",
    intro: `Für ${categoryName || "diesen Bereich"} sind aktuell keine Stellen offen. Hinterlasse deine Daten und wir informieren dich, sobald wieder Stellen verfügbar sind.`,
    name: "Name", email: "E-Mail-Adresse", phone: "Telefonnummer", message: "Nachricht (optional)",
    notify: "Ich möchte benachrichtigt werden, sobald Stellen verfügbar sind.",
    submit: "Interesse hinterlassen", success: "Dein Interesse wurde gespeichert. Wir informieren dich, sobald passende Stellen verfügbar sind.",
  } : isArabic ? {
    title: "تسجيل الاهتمام بالتدريب المهني",
    intro: `لا توجد وظائف متاحة حاليًا في ${categoryName || "هذا المجال"}. اترك بياناتك وسنبلغك عند توفر فرص جديدة.`,
    name: "الاسم", email: "البريد الإلكتروني", phone: "رقم الهاتف", message: "رسالة (اختياري)",
    notify: "أرغب في تلقي إشعار عند توفر وظائف.",
    submit: "سجّل اهتمامك", success: "تم تسجيل اهتمامك وسنبلغك عند توفر فرص مناسبة.",
  } : {
    title: "Register your Ausbildung interest",
    intro: `There are currently no open positions in ${categoryName || "this field"}. Leave your details and we will notify you when positions become available.`,
    name: "Name", email: "Email address", phone: "Phone number", message: "Message (optional)",
    notify: "I would like to be notified when positions become available.",
    submit: "Register interest", success: "Your interest was saved. We will notify you when suitable positions become available.",
  };

  const submit = async (event) => {
    event.preventDefault();
    setStatus({ sending: true, success: "", error: "" });
    try {
      await api.post("/ausbildung/interests", { ...form, categoryId: Number(categoryId), interestType: "AUSBILDUNG" });
      setStatus({ sending: false, success: text.success, error: "" });
    } catch (err) {
      setStatus({ sending: false, success: "", error: err.response?.data?.message || "The interest could not be saved." });
    }
  };

  return (
    <Paper component="form" onSubmit={submit} sx={{ p: { xs: 2.5, md: 4 }, mt: 3, borderRadius: 3 }}>
      <Typography variant="h5" fontWeight={900} sx={{ mb: 1 }}>{text.title}</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>{text.intro}</Typography>
      {status.success && <Alert severity="success" sx={{ mb: 2 }}>{status.success}</Alert>}
      {status.error && <Alert severity="error" sx={{ mb: 2 }}>{status.error}</Alert>}
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}><TextField required fullWidth label={text.name} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Grid>
        <Grid item xs={12} md={4}><TextField required type="email" fullWidth label={text.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Grid>
        <Grid item xs={12} md={4}><TextField required type="tel" fullWidth label={text.phone} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Grid>
        <Grid item xs={12}><TextField fullWidth multiline minRows={4} label={text.message} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} /></Grid>
        <Grid item xs={12}><FormControlLabel control={<Checkbox checked={form.notifyWhenAvailable} onChange={(e) => setForm({ ...form, notifyWhenAvailable: e.target.checked })} />} label={text.notify} /></Grid>
        <Grid item xs={12}><Button type="submit" variant="contained" disabled={status.sending || !categoryId}>{status.sending ? "..." : text.submit}</Button></Grid>
      </Grid>
    </Paper>
  );
};

export default AusbildungInterestForm;
